import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'
import {
  Bar,
  ComposedChart,
  Label,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import BoxTitle from 'components/atoms/BoxTitle'
import { HowToReg } from '@mui/icons-material'
import { removeEmpty } from 'utils/helpers'
import { 
  useGET_kpiEvaluationStatsAccuracyRateQuery,
  useGET_kpiEvaluationStatsTimeOnTaskQuery,
  useGET_kpiEvaluationStatsGrowthTrendQuery,
} from 'redux/api/kpiEvaluationsApi'

const KpiPerformanceChart: FC<any> = ({filters = {}}) => {
  const { t } = useTranslation()

  const { data: chartAccuracy } = useGET_kpiEvaluationStatsAccuracyRateQuery(removeEmpty(filters) as any)
  const { data: chartTime } = useGET_kpiEvaluationStatsTimeOnTaskQuery(removeEmpty(filters) as any)
  const { data: chartGrowth } = useGET_kpiEvaluationStatsGrowthTrendQuery(removeEmpty(filters) as any)

  let data = {}
  if(chartAccuracy && chartTime && chartGrowth){

    
    chartAccuracy.forEach(d => { 
      data[d.month] = {
        "month": d.month,
        "accuracy_rate": d.avg_score,
      }
    })

    chartTime.forEach(d => {
      data[d.month]["time_on_task"] = d.avg_score
    })
    
    chartGrowth.forEach(d => {
      data[d.month]["growth_trend"] = d.avg_score
    })
  }

  return (
    <>{ data &&  Object.values(data).length>0 && 
    <div style={{ display: 'flex', width: '100%' }}>
      <Box className="thick-border plop-performance-chart" sx={{ width: '100%' }}> 
        <BoxTitle title={ t('common.average-level-of-performance') } icon={<HowToReg />} />
        <Box sx={{ paddingBottom: '40px', height: '344px' }}>
          <ResponsiveContainer width='100%' height='115%'>
            <ComposedChart 
              data={Object.values(data)}
              margin={{
                top: 20,
                right: 0,
                bottom: 40
              }}
            >
              <XAxis dataKey='month' interval={0} tick={<CustomizedAxisTick />}/>
              <YAxis type='number' domain={[0, 100]}  />
              <Legend layout="horizontal" verticalAlign="top" align="center" />
              <Tooltip />

              <Bar
                hide={false}
                dataKey='accuracy_rate'
                fill={"#b82aceff"}
                barSize={20}
                label={<CustomizedLabel />}
              /> 

              <Bar
                hide={false}
                dataKey='time_on_task'
                fill={"#da7108ff"}
                barSize={20}
                label={<CustomizedLabel />}
              /> 

              <Bar
                hide={false}
                dataKey='growth_trend'
                fill={"#08da21ff"}
                barSize={20}
                label={<CustomizedLabel />}
              /> 

              <Line
                type="linear"
                legendType='none' 
                hide={false}
                dataKey='bridge'
                stroke={"#ffd853"}
                strokeWidth={1}
                label={<CustomizedLabel />}
              /> 

            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      </Box>
      </div> }
      </>
  )
}

export default KpiPerformanceChart

export const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props

  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor='middle'>
      {`${value} %`}
    </text>
  )
}
export const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fontSize={10} textAnchor='end' fill='#666' transform='rotate(-35)'>
        {payload.value}
      </text>
    </g>
  )
}
